import { render } from "./MovieScreen.vue?vue&type=template&id=a1f563c6&scoped=true&ts=true&lang=pug"
import script from "./MovieScreen.vue?vue&type=script&lang=ts"
export * from "./MovieScreen.vue?vue&type=script&lang=ts"

import "./MovieScreen.vue?vue&type=style&index=0&id=a1f563c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f563c6"]])

export default __exports__